export default __webpack_public_path__ + "static/media/activities.b4d425d0.svg";